import dayjs from 'dayjs'

export function getDayJsDateFromMilliseconds(milliseconds) {
  const inSeconds = milliseconds / 1000

  const seconds = Math.floor(inSeconds % 60)
  const minutes = Math.floor((inSeconds / 60) % 60)

  return dayjs(
    `2022-04-17T12:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
  )
}
